"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.buildASAOperation = void 0;
var bignumber_js_1 = require("bignumber.js");
var types_1 = require("./types");
var operation_1 = require("../../operation");
var OperationTypeMap = {
    "0": "OUT",
    "1": "IN"
};
function buildASAOperation(arg) {
    return __awaiter(this, void 0, void 0, function () {
        var coreOperation, accountId, tokenId, algorandOperation, transaction, hash, algoOpeType, transferInfo, operationType, type, id, blockHeight, _a, value, receiver, _b, _c, fee, sender, date, _d, op;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    coreOperation = arg.coreOperation, accountId = arg.accountId, tokenId = arg.tokenId;
                    return [4 /*yield*/, coreOperation.asAlgorandOperation()];
                case 1:
                    algorandOperation = _e.sent();
                    return [4 /*yield*/, algorandOperation.getTransaction()];
                case 2:
                    transaction = _e.sent();
                    return [4 /*yield*/, transaction.getId()];
                case 3:
                    hash = _e.sent();
                    return [4 /*yield*/, algorandOperation.getAlgorandOperationType()];
                case 4:
                    algoOpeType = _e.sent();
                    if (![
                        types_1.AlgorandOperationTypeEnum.ASSET_OPT_OUT,
                        types_1.AlgorandOperationTypeEnum.ASSET_TRANSFER,
                    ].includes(algoOpeType)) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, transaction.getAssetTransferInfo()];
                case 5:
                    transferInfo = _e.sent();
                    return [4 /*yield*/, transferInfo.getAssetId()];
                case 6:
                    if ((_e.sent()) !== tokenId) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, coreOperation.getOperationType()];
                case 7:
                    operationType = _e.sent();
                    type = OperationTypeMap[operationType];
                    id = (0, operation_1.encodeOperationId)(accountId, hash, type);
                    _a = parseInt;
                    return [4 /*yield*/, transaction.getRound()];
                case 8:
                    blockHeight = _a.apply(void 0, [_e.sent()]);
                    return [4 /*yield*/, algorandOperation.getAssetAmount()];
                case 9:
                    value = _e.sent();
                    if (!(algoOpeType === 8)) return [3 /*break*/, 12];
                    return [4 /*yield*/, transferInfo.getRecipientAddress()];
                case 10:
                    _c = [
                        _e.sent()
                    ];
                    return [4 /*yield*/, transferInfo.getCloseAddress()];
                case 11:
                    _b = _c.concat([
                        _e.sent()
                    ]);
                    return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, transferInfo.getRecipientAddress()];
                case 13:
                    _b = [_e.sent()];
                    _e.label = 14;
                case 14:
                    receiver = _b;
                    return [4 /*yield*/, transaction.getFee()];
                case 15:
                    fee = _e.sent();
                    return [4 /*yield*/, transaction.getSender()];
                case 16:
                    sender = _e.sent();
                    _d = Date.bind;
                    return [4 /*yield*/, coreOperation.getDate()];
                case 17:
                    date = new (_d.apply(Date, [void 0, _e.sent()]))();
                    op = {
                        id: id,
                        type: type,
                        value: new bignumber_js_1.BigNumber(value),
                        hash: hash,
                        fee: new bignumber_js_1.BigNumber(fee),
                        senders: [sender],
                        recipients: receiver,
                        blockHeight: blockHeight,
                        blockHash: null,
                        accountId: accountId,
                        date: date,
                        extra: {}
                    };
                    return [2 /*return*/, op];
            }
        });
    });
}
exports.buildASAOperation = buildASAOperation;
//# sourceMappingURL=buildASAOperation.js.map